import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VariableService {
    variables;

    constructor(private http: HttpClient) {
    }

    createVariable(body) {
        return this.http.post(`${environment.apiUrl}/variable`, body);
    }

    getVariable(id: string) {
        return this.http.get(`${environment.apiUrl}/variable/${id}`).pipe(map(({ variable }: any) => variable));
    }

    initVariables() {
        if(this.variables?.length) return;
        return this.http.get(`${environment.apiUrl}/variables`).pipe(map(({ variables }: any) => this.variables = variables));
    }

    updateVariable(body) {
        return this.http.put(`${environment.apiUrl}/variable`, body);
    }
}
